import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { egretAnimations } from '@shared/animations/egret-animations';
import { DashboardService } from '@shared/services/api/dashboard.service';
import { LayoutService } from '@shared/services/system/layout.service';
import { dashboardConfigs } from '@shared/config';
import * as _ from 'lodash';
import { ThemeService } from '@shared/services/system/theme.service';
@Component({
  selector: 'app-quotation-dashboard',
  templateUrl: './quotation-dashboard.component.html',
  animations: egretAnimations
})
export class QuotationDashboardComponent implements OnInit, OnDestroy {
  _ = _;
  public loading = false;
  public dashboard;
  public displays = dashboardConfigs.quotation;
  public onRefreshSub;
  @Output() onClickDashboard = new EventEmitter();

  constructor(
    private dashboardService: DashboardService,
    private layout: LayoutService,
    public theme: ThemeService
  ) {
  }

  ngOnInit() {
    this.onRefreshSub = this.layout.onRefresh.subscribe(() => this.refresh());
    this.refresh();
  }

  refresh() {
    this.loading = true;
    this.dashboardService.getQuotationDashboard()
      .finally(() => this.loading = false)
      .subscribe((data) => {
        this.dashboard = data;
      });
  }

  ngOnDestroy() {
    if (this.onRefreshSub) {
      this.onRefreshSub.unsubscribe();
    }
  }

  openTable(dashboardGroup, dashboardType) {
    this.onClickDashboard.emit({ group: dashboardGroup, item: dashboardType });
  }
}
